// Typelizer digest d23fdbe720431410670018c71bf10fc4
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
export { default as Routes } from './RoutesController'
export { default as appleAppSiteAssociations } from './AppleAppSiteAssociationsController'
export { default as designSystem } from './DesignSystemController'
export { default as frontAccountNames } from './Front/AccountNamesController'
export { default as frontAccountSelections } from './Front/AccountSelectionsController'
export { default as frontAccountantClients } from './Front/Accountant/ClientsController'
export { default as frontAccountantClientsChartApprovals } from './Front/Accountant/Clients/ChartApprovalsController'
export { default as frontAccountantClientsLedgerAccounts } from './Front/Accountant/Clients/LedgerAccountsController'
export { default as frontAccountantClientsPeriodStarts } from './Front/Accountant/Clients/PeriodStartsController'
export { default as frontAccountantClientsSetups } from './Front/Accountant/Clients/SetupsController'
export { default as frontAccountantClientsStarts } from './Front/Accountant/Clients/StartsController'
export { default as frontAccountantDeadlines } from './Front/Accountant/DeadlinesController'
export { default as frontAccountantFirmAssignments } from './Front/Accountant/Firm/AssignmentsController'
export { default as frontAccountantFirmEngagements } from './Front/Accountant/Firm/EngagementsController'
export { default as frontAccountantFirmStaff } from './Front/Accountant/Firm/StaffController'
export { default as frontAccountantFirms } from './Front/Accountant/FirmsController'
export { default as frontAccountantOnboardings } from './Front/Accountant/OnboardingsController'
export { default as frontAccountantProfiles } from './Front/Accountant/ProfilesController'
export { default as frontAccounts } from './Front/AccountsController'
export { default as frontActivities } from './Front/ActivitiesController'
export { default as frontActivitiesDismissals } from './Front/Activities/DismissalsController'
export { default as frontBankAccounts } from './Front/BankAccountsController'
export { default as frontBankAccountsRawBankTransactions } from './Front/BankAccounts/RawBankTransactionsController'
export { default as frontBankAccountsStatements } from './Front/BankAccounts/StatementsController'
export { default as frontBankConnections } from './Front/BankConnectionsController'
export { default as frontBankConnectionsAuthorizations } from './Front/BankConnections/AuthorizationsController'
export { default as frontBankConnectionsCallbacks } from './Front/BankConnections/CallbacksController'
export { default as frontBankConnectionsInstitutionSelections } from './Front/BankConnections/InstitutionSelectionsController'
export { default as frontBankConnectionsInstitutions } from './Front/BankConnections/InstitutionsController'
export { default as frontBankStatementFiles } from './Front/BankStatementFilesController'
export { default as frontBankStatementFilesAssignments } from './Front/BankStatementFiles/AssignmentsController'
export { default as frontBankStatementFilesPdfs } from './Front/BankStatementFiles/PdfsController'
export { default as frontBankStatementUploads } from './Front/BankStatementUploadsController'
export { default as frontBankStatementUploadsBankAccounts } from './Front/BankStatementUploads/BankAccountsController'
export { default as frontBankStatementUploadsRows } from './Front/BankStatementUploads/RowsController'
export { default as frontBankSyncs } from './Front/BankSyncsController'
export { default as frontBankSyncsAcknowledgements } from './Front/BankSyncs/AcknowledgementsController'
export { default as frontBankSyncsRetries } from './Front/BankSyncs/RetriesController'
export { default as frontBulkCounterparties } from './Front/BulkCounterpartiesController'
export { default as frontBulkExtracts } from './Front/BulkExtractsController'
export { default as frontCashAccounts } from './Front/CashAccountsController'
export { default as frontCashAccountsCashCounts } from './Front/CashAccounts/CashCountsController'
export { default as frontCompanies } from './Front/CompaniesController'
export { default as frontCompaniesArchives } from './Front/Companies/ArchivesController'
export { default as frontCompanyIdentities } from './Front/CompanyIdentitiesController'
export { default as frontCompanyIdentityConfirmations } from './Front/CompanyIdentityConfirmationsController'
export { default as frontCounterparties } from './Front/CounterpartiesController'
export { default as frontCounterpartiesBulkDeletions } from './Front/Counterparties/BulkDeletionsController'
export { default as frontCounterpartiesContacts } from './Front/Counterparties/ContactsController'
export { default as frontCounterpartiesMerges } from './Front/Counterparties/MergesController'
export { default as frontCounterpartiesRoles } from './Front/Counterparties/RolesController'
export { default as frontCounterpartiesSettlementSales } from './Front/Counterparties/SettlementSalesController'
export { default as frontCounterpartiesStatements } from './Front/Counterparties/StatementsController'
export { default as frontDevActions } from './Front/DevActionsController'
export { default as frontDocuments } from './Front/DocumentsController'
export { default as frontDocumentsCashDiscounts } from './Front/Documents/CashDiscountsController'
export { default as frontDocumentsCashPayments } from './Front/Documents/CashPaymentsController'
export { default as frontDocumentsCompanies } from './Front/Documents/CompaniesController'
export { default as frontDocumentsCounterparties } from './Front/Documents/CounterpartiesController'
export { default as frontDocumentsDeliveryDates } from './Front/Documents/DeliveryDatesController'
export { default as frontDocumentsDetailedExtractions } from './Front/Documents/DetailedExtractionsController'
export { default as frontDocumentsDocuments } from './Front/Documents/DocumentsController'
export { default as frontDocumentsExtractions } from './Front/Documents/ExtractionsController'
export { default as frontDocumentsImages } from './Front/Documents/ImagesController'
export { default as frontDocumentsInvoicePdfs } from './Front/Documents/InvoicePdfsController'
export { default as frontDocumentsPayments } from './Front/Documents/PaymentsController'
export { default as frontDocumentsPurchaseOrders } from './Front/Documents/PurchaseOrdersController'
export { default as frontDocumentsRebills } from './Front/Documents/RebillsController'
export { default as frontDocumentsReviewCompletions } from './Front/Documents/ReviewCompletionsController'
export { default as frontDocumentsReviewDecisions } from './Front/Documents/ReviewDecisionsController'
export { default as frontDocumentsReviewQueues } from './Front/Documents/ReviewQueuesController'
export { default as frontDocumentsReviews } from './Front/Documents/ReviewsController'
export { default as frontFeedbacks } from './Front/FeedbacksController'
export { default as frontIncomingEmailAllowedSenders } from './Front/IncomingEmailAllowedSendersController'
export { default as frontIncomingEmailItemsAssignments } from './Front/IncomingEmailItems/AssignmentsController'
export { default as frontIncomingEmailItemsSkips } from './Front/IncomingEmailItems/SkipsController'
export { default as frontIncomingEmails } from './Front/IncomingEmailsController'
export { default as frontInvoiceImports } from './Front/InvoiceImportsController'
export { default as frontInvoiceSettings } from './Front/InvoiceSettingsController'
export { default as frontInvoiceTemplates } from './Front/InvoiceTemplatesController'
export { default as frontInvoiceTemplatesDrafts } from './Front/InvoiceTemplates/DraftsController'
export { default as frontInvoices } from './Front/InvoicesController'
export { default as frontInvoicesAttachments } from './Front/Invoices/AttachmentsController'
export { default as frontInvoicesCancellations } from './Front/Invoices/CancellationsController'
export { default as frontInvoicesCreditNotes } from './Front/Invoices/CreditNotesController'
export { default as frontInvoicesDeliveries } from './Front/Invoices/DeliveriesController'
export { default as frontInvoicesDuplicates } from './Front/Invoices/DuplicatesController'
export { default as frontInvoicesIssues } from './Front/Invoices/IssuesController'
export { default as frontInvoicesPreviews } from './Front/Invoices/PreviewsController'
export { default as frontInvoicesRebilledExpenses } from './Front/Invoices/RebilledExpensesController'
export { default as frontInvoicesReminders } from './Front/Invoices/RemindersController'
export { default as frontInvoicesSettlements } from './Front/Invoices/SettlementsController'
export { default as frontLedgerAccounts } from './Front/Ledger/AccountsController'
export { default as frontLedgerBalanceSheets } from './Front/Ledger/BalanceSheetsController'
export { default as frontLedgerBatchVerifications } from './Front/Ledger/BatchVerificationsController'
export { default as frontLedgerCounterparties } from './Front/Ledger/CounterpartiesController'
export { default as frontLedgerCounterpartiesConfirmations } from './Front/Ledger/Counterparties/ConfirmationsController'
export { default as frontLedgerCounterpartiesCorrections } from './Front/Ledger/Counterparties/CorrectionsController'
export { default as frontLedgerDocuments } from './Front/Ledger/DocumentsController'
export { default as frontLedgerDocumentsBreakdowns } from './Front/Ledger/Documents/BreakdownsController'
export { default as frontLedgerDocumentsCorrections } from './Front/Ledger/Documents/CorrectionsController'
export { default as frontLedgerDocumentsExpenseAccounts } from './Front/Ledger/Documents/ExpenseAccountsController'
export { default as frontLedgerDocumentsPostingRules } from './Front/Ledger/Documents/PostingRulesController'
export { default as frontLedgerDocumentsQuestions } from './Front/Ledger/Documents/QuestionsController'
export { default as frontLedgerDocumentsVerifications } from './Front/Ledger/Documents/VerificationsController'
export { default as frontLedgerIssuesResolutions } from './Front/Ledger/Issues/ResolutionsController'
export { default as frontLedgerJournalEntries } from './Front/Ledger/JournalEntriesController'
export { default as frontLedgerJournalEntriesExports } from './Front/Ledger/JournalEntries/ExportsController'
export { default as frontLedgerManualJournals } from './Front/Ledger/ManualJournalsController'
export { default as frontLedgerManualJournalsPostings } from './Front/Ledger/ManualJournals/PostingsController'
export { default as frontLedgerPayments } from './Front/Ledger/PaymentsController'
export { default as frontLedgerPaymentsCategories } from './Front/Ledger/Payments/CategoriesController'
export { default as frontLedgerPaymentsDocuments } from './Front/Ledger/Payments/DocumentsController'
export { default as frontLedgerPaymentsQuestions } from './Front/Ledger/Payments/QuestionsController'
export { default as frontLedgerPaymentsVerifications } from './Front/Ledger/Payments/VerificationsController'
export { default as frontLedgerPeriods } from './Front/Ledger/PeriodsController'
export { default as frontLedgerPeriodsApprovals } from './Front/Ledger/Periods/ApprovalsController'
export { default as frontLedgerPeriodsFilings } from './Front/Ledger/Periods/FilingsController'
export { default as frontLedgerPeriodsPreparations } from './Front/Ledger/Periods/PreparationsController'
export { default as frontLedgerProfitAndLosses } from './Front/Ledger/ProfitAndLossesController'
export { default as frontLedgerQuestionReminders } from './Front/Ledger/QuestionRemindersController'
export { default as frontLedgerQuestionsMessages } from './Front/Ledger/Questions/MessagesController'
export { default as frontLedgerQuestionsResolutions } from './Front/Ledger/Questions/ResolutionsController'
export { default as frontLedgerReviewQueues } from './Front/Ledger/ReviewQueuesController'
export { default as frontLedgerReviewQueuesCounterparties } from './Front/Ledger/ReviewQueues/CounterpartiesController'
export { default as frontLedgerReviewQueuesPaymentGroups } from './Front/Ledger/ReviewQueues/PaymentGroupsController'
export { default as frontLedgerReviewQueuesPayments } from './Front/Ledger/ReviewQueues/PaymentsController'
export { default as frontLedgerReviewQueuesPaymentsVerifications } from './Front/Ledger/ReviewQueues/Payments/VerificationsController'
export { default as frontLedgerReviewQueuesVerifications } from './Front/Ledger/ReviewQueues/VerificationsController'
export { default as frontLedgerReviews } from './Front/Ledger/ReviewsController'
export { default as frontLedgerTrialBalances } from './Front/Ledger/TrialBalancesController'
export { default as frontLedgerTrustRules } from './Front/Ledger/TrustRulesController'
export { default as frontLedgerVatReturns } from './Front/Ledger/VatReturnsController'
export { default as frontLedgerVatReturnsDeclarations } from './Front/Ledger/VatReturns/DeclarationsController'
export { default as frontLedgerVatReturnsExports } from './Front/Ledger/VatReturns/ExportsController'
export { default as frontLedgerVatReturnsSummaries } from './Front/Ledger/VatReturns/SummariesController'
export { default as frontLedgerVatSettings } from './Front/Ledger/VatSettingsController'
export { default as frontLedgerViesReturns } from './Front/Ledger/ViesReturnsController'
export { default as frontLedgerViesReturnsDeclarations } from './Front/Ledger/ViesReturns/DeclarationsController'
export { default as frontLedgerViesReturnsExports } from './Front/Ledger/ViesReturns/ExportsController'
export { default as frontLedgerViesReturnsFilings } from './Front/Ledger/ViesReturns/FilingsController'
export { default as frontMobileDevices } from './Front/MobileDevicesController'
export { default as frontMobilePairings } from './Front/MobilePairingsController'
export { default as frontOnboarding } from './Front/OnboardingController'
export { default as frontOverviewDashboards } from './Front/Overview/DashboardsController'
export { default as frontOverviewMatchSuggestionsAcceptances } from './Front/Overview/MatchSuggestions/AcceptancesController'
export { default as frontOverviewMatchSuggestionsRejections } from './Front/Overview/MatchSuggestions/RejectionsController'
export { default as frontOverviewMonthEndAutoMatches } from './Front/Overview/MonthEndAutoMatchesController'
export { default as frontOverviewMonthEndConnections } from './Front/Overview/MonthEndConnectionsController'
export { default as frontOverviewMonthEndExports } from './Front/Overview/MonthEndExportsController'
export { default as frontOverviewMonthEndHandOvers } from './Front/Overview/MonthEndHandOversController'
export { default as frontOverviewMonthEndReopenings } from './Front/Overview/MonthEndReopeningsController'
export { default as frontOverviewMonthEnds } from './Front/Overview/MonthEndsController'
export { default as frontOverviewYears } from './Front/Overview/YearsController'
export { default as frontPasskeys } from './Front/PasskeysController'
export { default as frontPasskeysAuthenticationChallenges } from './Front/Passkeys/AuthenticationChallengesController'
export { default as frontPasskeysReauthentications } from './Front/Passkeys/ReauthenticationsController'
export { default as frontPasskeysRegistrationChallenges } from './Front/Passkeys/RegistrationChallengesController'
export { default as frontPasskeysSessions } from './Front/Passkeys/SessionsController'
export { default as frontPaymentMatchingRules } from './Front/PaymentMatchingRulesController'
export { default as frontPayments } from './Front/PaymentsController'
export { default as frontPaymentsCashTransfers } from './Front/Payments/CashTransfersController'
export { default as frontPaymentsCategoryRuleDrafts } from './Front/Payments/CategoryRuleDraftsController'
export { default as frontPaymentsCategoryTakeovers } from './Front/Payments/CategoryTakeoversController'
export { default as frontPaymentsCounterparties } from './Front/Payments/CounterpartiesController'
export { default as frontPaymentsCounterpartyRuleDrafts } from './Front/Payments/CounterpartyRuleDraftsController'
export { default as frontPaymentsCreditNotes } from './Front/Payments/CreditNotesController'
export { default as frontPaymentsDocuments } from './Front/Payments/DocumentsController'
export { default as frontPaymentsInvoices } from './Front/Payments/InvoicesController'
export { default as frontPaymentsPayments } from './Front/Payments/PaymentsController'
export { default as frontPaymentsReferenceDocuments } from './Front/Payments/ReferenceDocumentsController'
export { default as frontPaymentsReplacementDocuments } from './Front/Payments/ReplacementDocumentsController'
export { default as frontPaymentsSyncAccounts } from './Front/Payments/SyncAccountsController'
export { default as frontProducts } from './Front/ProductsController'
export { default as frontProductsPrices } from './Front/Products/PricesController'
export { default as frontProfiles } from './Front/ProfilesController'
export { default as frontPurchaseOrders } from './Front/PurchaseOrdersController'
export { default as frontPurchaseOrdersApprovals } from './Front/PurchaseOrders/ApprovalsController'
export { default as frontPurchaseOrdersDeliveries } from './Front/PurchaseOrders/DeliveriesController'
export { default as frontPurchaseOrdersDuplicates } from './Front/PurchaseOrders/DuplicatesController'
export { default as frontPurchaseOrdersFinalizations } from './Front/PurchaseOrders/FinalizationsController'
export { default as frontPurchaseOrdersPdfs } from './Front/PurchaseOrders/PdfsController'
export { default as frontPurchaseOrdersPreviews } from './Front/PurchaseOrders/PreviewsController'
export { default as frontPurchaseOrdersStatuses } from './Front/PurchaseOrders/StatusesController'
export { default as frontQuestions } from './Front/QuestionsController'
export { default as frontQuestionsMessages } from './Front/Questions/MessagesController'
export { default as frontRecurringInvoices } from './Front/RecurringInvoicesController'
export { default as frontRecurringInvoicesPauses } from './Front/RecurringInvoices/PausesController'
export { default as frontRecurringInvoicesRuns } from './Front/RecurringInvoices/RunsController'
export { default as frontReminderSettings } from './Front/ReminderSettingsController'
export { default as frontSalesDocuments } from './Front/SalesDocumentsController'
export { default as frontSalesDocumentsAcceptances } from './Front/SalesDocuments/AcceptancesController'
export { default as frontSalesDocumentsAdvanceInvoices } from './Front/SalesDocuments/AdvanceInvoicesController'
export { default as frontSalesDocumentsConversions } from './Front/SalesDocuments/ConversionsController'
export { default as frontSalesDocumentsDeclines } from './Front/SalesDocuments/DeclinesController'
export { default as frontSalesDocumentsDeliveries } from './Front/SalesDocuments/DeliveriesController'
export { default as frontSalesDocumentsDuplicates } from './Front/SalesDocuments/DuplicatesController'
export { default as frontSalesDocumentsFinalizations } from './Front/SalesDocuments/FinalizationsController'
export { default as frontSalesDocumentsPdfs } from './Front/SalesDocuments/PdfsController'
export { default as frontSalesDocumentsPreviews } from './Front/SalesDocuments/PreviewsController'
export { default as frontSettings } from './Front/SettingsController'
export { default as frontShowcaseSessions } from './Front/ShowcaseSessionsController'
export { default as frontStores } from './Front/StoresController'
export { default as frontTeamFirmsEngagements } from './Front/Team/Firms/EngagementsController'
export { default as frontTeamInvitations } from './Front/Team/InvitationsController'
export { default as frontTeamInvitationsDeliveries } from './Front/Team/Invitations/DeliveriesController'
export { default as frontTeamMembers } from './Front/Team/MembersController'
export { default as frontTeamMembersCompanies } from './Front/Team/Members/CompaniesController'
export { default as frontTeamMembersReactivations } from './Front/Team/Members/ReactivationsController'
export { default as frontUsers } from './Front/UsersController'
export { default as frontUsersInvitations } from './Front/Users/InvitationsController'
export { default as frontUsersLoginCodes } from './Front/Users/LoginCodesController'
export { default as frontUsersOauthCallbacks } from './Front/Users/OauthCallbacksController'
export { default as frontUsersOauthStarts } from './Front/Users/OauthStartsController'
export { default as frontUsersSessions } from './Front/Users/SessionsController'
export { default as ideaBoardComments } from './IdeaBoard/CommentsController'
export { default as ideaBoardIdeas } from './IdeaBoard/IdeasController'
export { default as ideaBoardVotes } from './IdeaBoard/VotesController'
export { default as mobilePairingLinks } from './MobilePairingLinksController'
export { default as pages } from './PagesController'
export { default as turboNativeNavigation } from './Turbo/Native/NavigationController'

import _frontPaymentMatchingRules from './Front/PaymentMatchingRulesController'
import _frontAccounts from './Front/AccountsController'
import _frontAccountNames from './Front/AccountNamesController'
import _frontAccountSelections from './Front/AccountSelectionsController'
import _frontSettings from './Front/SettingsController'
import _frontAccountantClients from './Front/Accountant/ClientsController'
import _frontAccountantClientsChartApprovals from './Front/Accountant/Clients/ChartApprovalsController'
import _frontAccountantClientsLedgerAccounts from './Front/Accountant/Clients/LedgerAccountsController'
import _frontAccountantClientsPeriodStarts from './Front/Accountant/Clients/PeriodStartsController'
import _frontAccountantClientsSetups from './Front/Accountant/Clients/SetupsController'
import _frontAccountantClientsStarts from './Front/Accountant/Clients/StartsController'
import _frontAccountantDeadlines from './Front/Accountant/DeadlinesController'
import _frontAccountantFirms from './Front/Accountant/FirmsController'
import _frontAccountantFirmAssignments from './Front/Accountant/Firm/AssignmentsController'
import _frontAccountantFirmEngagements from './Front/Accountant/Firm/EngagementsController'
import _frontAccountantFirmStaff from './Front/Accountant/Firm/StaffController'
import _frontAccountantOnboardings from './Front/Accountant/OnboardingsController'
import _frontAccountantProfiles from './Front/Accountant/ProfilesController'
import _Routes from './RoutesController'
import _frontActivities from './Front/ActivitiesController'
import _frontActivitiesDismissals from './Front/Activities/DismissalsController'
import _appleAppSiteAssociations from './AppleAppSiteAssociationsController'
import _frontDocuments from './Front/DocumentsController'
import _frontUsersOauthCallbacks from './Front/Users/OauthCallbacksController'
import _frontBankAccounts from './Front/BankAccountsController'
import _frontBankAccountsRawBankTransactions from './Front/BankAccounts/RawBankTransactionsController'
import _frontBankAccountsStatements from './Front/BankAccounts/StatementsController'
import _frontBankConnections from './Front/BankConnectionsController'
import _frontBankConnectionsAuthorizations from './Front/BankConnections/AuthorizationsController'
import _frontBankConnectionsCallbacks from './Front/BankConnections/CallbacksController'
import _frontBankConnectionsInstitutionSelections from './Front/BankConnections/InstitutionSelectionsController'
import _frontBankConnectionsInstitutions from './Front/BankConnections/InstitutionsController'
import _frontBankStatementFiles from './Front/BankStatementFilesController'
import _frontBankStatementFilesAssignments from './Front/BankStatementFiles/AssignmentsController'
import _frontBankStatementFilesPdfs from './Front/BankStatementFiles/PdfsController'
import _frontBankStatementUploads from './Front/BankStatementUploadsController'
import _frontBankStatementUploadsBankAccounts from './Front/BankStatementUploads/BankAccountsController'
import _frontBankStatementUploadsRows from './Front/BankStatementUploads/RowsController'
import _frontBankSyncs from './Front/BankSyncsController'
import _frontBankSyncsAcknowledgements from './Front/BankSyncs/AcknowledgementsController'
import _frontBankSyncsRetries from './Front/BankSyncs/RetriesController'
import _frontBulkCounterparties from './Front/BulkCounterpartiesController'
import _frontPayments from './Front/PaymentsController'
import _frontBulkExtracts from './Front/BulkExtractsController'
import _frontCashAccounts from './Front/CashAccountsController'
import _frontCashAccountsCashCounts from './Front/CashAccounts/CashCountsController'
import _frontCompanies from './Front/CompaniesController'
import _frontCompaniesArchives from './Front/Companies/ArchivesController'
import _frontCompanyIdentities from './Front/CompanyIdentitiesController'
import _frontCompanyIdentityConfirmations from './Front/CompanyIdentityConfirmationsController'
import _frontUsersSessions from './Front/Users/SessionsController'
import _frontCounterparties from './Front/CounterpartiesController'
import _frontCounterpartiesBulkDeletions from './Front/Counterparties/BulkDeletionsController'
import _frontCounterpartiesContacts from './Front/Counterparties/ContactsController'
import _frontCounterpartiesMerges from './Front/Counterparties/MergesController'
import _frontCounterpartiesRoles from './Front/Counterparties/RolesController'
import _frontCounterpartiesSettlementSales from './Front/Counterparties/SettlementSalesController'
import _frontCounterpartiesStatements from './Front/Counterparties/StatementsController'
import _frontDocumentsCashDiscounts from './Front/Documents/CashDiscountsController'
import _frontDocumentsCashPayments from './Front/Documents/CashPaymentsController'
import _frontDocumentsCompanies from './Front/Documents/CompaniesController'
import _frontDocumentsCounterparties from './Front/Documents/CounterpartiesController'
import _frontDocumentsDetailedExtractions from './Front/Documents/DetailedExtractionsController'
import _frontDocumentsDocuments from './Front/Documents/DocumentsController'
import _frontDocumentsExtractions from './Front/Documents/ExtractionsController'
import _frontDocumentsImages from './Front/Documents/ImagesController'
import _frontDocumentsInvoicePdfs from './Front/Documents/InvoicePdfsController'
import _frontDocumentsPayments from './Front/Documents/PaymentsController'
import _frontDocumentsPurchaseOrders from './Front/Documents/PurchaseOrdersController'
import _frontDocumentsRebills from './Front/Documents/RebillsController'
import _frontDocumentsReviews from './Front/Documents/ReviewsController'
import _frontDocumentsReviewCompletions from './Front/Documents/ReviewCompletionsController'
import _frontDocumentsReviewDecisions from './Front/Documents/ReviewDecisionsController'
import _frontDocumentsDeliveryDates from './Front/Documents/DeliveryDatesController'
import _frontDocumentsReviewQueues from './Front/Documents/ReviewQueuesController'
import _frontInvoices from './Front/InvoicesController'
import _frontLedgerManualJournals from './Front/Ledger/ManualJournalsController'
import _frontPurchaseOrders from './Front/PurchaseOrdersController'
import _frontRecurringInvoices from './Front/RecurringInvoicesController'
import _frontSalesDocuments from './Front/SalesDocumentsController'
import _frontIncomingEmails from './Front/IncomingEmailsController'
import _frontFeedbacks from './Front/FeedbacksController'
import _frontUsersOauthStarts from './Front/Users/OauthStartsController'
import _ideaBoardIdeas from './IdeaBoard/IdeasController'
import _ideaBoardComments from './IdeaBoard/CommentsController'
import _ideaBoardVotes from './IdeaBoard/VotesController'
import _frontIncomingEmailAllowedSenders from './Front/IncomingEmailAllowedSendersController'
import _frontIncomingEmailItemsAssignments from './Front/IncomingEmailItems/AssignmentsController'
import _frontIncomingEmailItemsSkips from './Front/IncomingEmailItems/SkipsController'
import _frontUsersInvitations from './Front/Users/InvitationsController'
import _frontInvoicesAttachments from './Front/Invoices/AttachmentsController'
import _frontInvoicesCancellations from './Front/Invoices/CancellationsController'
import _frontInvoicesCreditNotes from './Front/Invoices/CreditNotesController'
import _frontInvoicesDeliveries from './Front/Invoices/DeliveriesController'
import _frontInvoicesDuplicates from './Front/Invoices/DuplicatesController'
import _frontInvoiceImports from './Front/InvoiceImportsController'
import _frontInvoicesIssues from './Front/Invoices/IssuesController'
import _frontInvoicesPreviews from './Front/Invoices/PreviewsController'
import _frontInvoicesRebilledExpenses from './Front/Invoices/RebilledExpensesController'
import _frontInvoicesReminders from './Front/Invoices/RemindersController'
import _frontInvoiceSettings from './Front/InvoiceSettingsController'
import _frontInvoicesSettlements from './Front/Invoices/SettlementsController'
import _frontInvoiceTemplates from './Front/InvoiceTemplatesController'
import _frontInvoiceTemplatesDrafts from './Front/InvoiceTemplates/DraftsController'
import _frontLedgerAccounts from './Front/Ledger/AccountsController'
import _frontLedgerBalanceSheets from './Front/Ledger/BalanceSheetsController'
import _frontLedgerBatchVerifications from './Front/Ledger/BatchVerificationsController'
import _frontLedgerCounterparties from './Front/Ledger/CounterpartiesController'
import _frontLedgerCounterpartiesConfirmations from './Front/Ledger/Counterparties/ConfirmationsController'
import _frontLedgerCounterpartiesCorrections from './Front/Ledger/Counterparties/CorrectionsController'
import _frontLedgerDocuments from './Front/Ledger/DocumentsController'
import _frontLedgerDocumentsBreakdowns from './Front/Ledger/Documents/BreakdownsController'
import _frontLedgerDocumentsCorrections from './Front/Ledger/Documents/CorrectionsController'
import _frontLedgerDocumentsExpenseAccounts from './Front/Ledger/Documents/ExpenseAccountsController'
import _frontLedgerDocumentsPostingRules from './Front/Ledger/Documents/PostingRulesController'
import _frontLedgerDocumentsQuestions from './Front/Ledger/Documents/QuestionsController'
import _frontLedgerDocumentsVerifications from './Front/Ledger/Documents/VerificationsController'
import _frontLedgerJournalEntriesExports from './Front/Ledger/JournalEntries/ExportsController'
import _frontLedgerIssuesResolutions from './Front/Ledger/Issues/ResolutionsController'
import _frontLedgerJournalEntries from './Front/Ledger/JournalEntriesController'
import _frontLedgerManualJournalsPostings from './Front/Ledger/ManualJournals/PostingsController'
import _frontLedgerPayments from './Front/Ledger/PaymentsController'
import _frontLedgerPaymentsCategories from './Front/Ledger/Payments/CategoriesController'
import _frontLedgerPaymentsDocuments from './Front/Ledger/Payments/DocumentsController'
import _frontLedgerPaymentsQuestions from './Front/Ledger/Payments/QuestionsController'
import _frontLedgerPaymentsVerifications from './Front/Ledger/Payments/VerificationsController'
import _frontLedgerPeriods from './Front/Ledger/PeriodsController'
import _frontLedgerPeriodsApprovals from './Front/Ledger/Periods/ApprovalsController'
import _frontLedgerPeriodsFilings from './Front/Ledger/Periods/FilingsController'
import _frontLedgerPeriodsPreparations from './Front/Ledger/Periods/PreparationsController'
import _frontLedgerProfitAndLosses from './Front/Ledger/ProfitAndLossesController'
import _frontLedgerQuestionsMessages from './Front/Ledger/Questions/MessagesController'
import _frontLedgerQuestionReminders from './Front/Ledger/QuestionRemindersController'
import _frontLedgerQuestionsResolutions from './Front/Ledger/Questions/ResolutionsController'
import _frontLedgerReviews from './Front/Ledger/ReviewsController'
import _frontLedgerReviewQueues from './Front/Ledger/ReviewQueuesController'
import _frontLedgerReviewQueuesCounterparties from './Front/Ledger/ReviewQueues/CounterpartiesController'
import _frontLedgerReviewQueuesPayments from './Front/Ledger/ReviewQueues/PaymentsController'
import _frontLedgerReviewQueuesPaymentGroups from './Front/Ledger/ReviewQueues/PaymentGroupsController'
import _frontLedgerReviewQueuesPaymentsVerifications from './Front/Ledger/ReviewQueues/Payments/VerificationsController'
import _frontLedgerReviewQueuesVerifications from './Front/Ledger/ReviewQueues/VerificationsController'
import _frontLedgerTrialBalances from './Front/Ledger/TrialBalancesController'
import _frontLedgerTrustRules from './Front/Ledger/TrustRulesController'
import _frontLedgerVatReturns from './Front/Ledger/VatReturnsController'
import _frontLedgerVatReturnsDeclarations from './Front/Ledger/VatReturns/DeclarationsController'
import _frontLedgerVatReturnsExports from './Front/Ledger/VatReturns/ExportsController'
import _frontLedgerVatReturnsSummaries from './Front/Ledger/VatReturns/SummariesController'
import _frontLedgerVatSettings from './Front/Ledger/VatSettingsController'
import _frontLedgerViesReturns from './Front/Ledger/ViesReturnsController'
import _frontLedgerViesReturnsDeclarations from './Front/Ledger/ViesReturns/DeclarationsController'
import _frontLedgerViesReturnsExports from './Front/Ledger/ViesReturns/ExportsController'
import _frontLedgerViesReturnsFilings from './Front/Ledger/ViesReturns/FilingsController'
import _frontUsersLoginCodes from './Front/Users/LoginCodesController'
import _frontMobileDevices from './Front/MobileDevicesController'
import _frontMobilePairings from './Front/MobilePairingsController'
import _mobilePairingLinks from './MobilePairingLinksController'
import _frontOnboarding from './Front/OnboardingController'
import _frontOverviewDashboards from './Front/Overview/DashboardsController'
import _frontOverviewMatchSuggestionsAcceptances from './Front/Overview/MatchSuggestions/AcceptancesController'
import _frontOverviewMatchSuggestionsRejections from './Front/Overview/MatchSuggestions/RejectionsController'
import _frontOverviewMonthEnds from './Front/Overview/MonthEndsController'
import _frontOverviewMonthEndAutoMatches from './Front/Overview/MonthEndAutoMatchesController'
import _frontOverviewMonthEndConnections from './Front/Overview/MonthEndConnectionsController'
import _frontOverviewMonthEndExports from './Front/Overview/MonthEndExportsController'
import _frontOverviewMonthEndHandOvers from './Front/Overview/MonthEndHandOversController'
import _frontOverviewMonthEndReopenings from './Front/Overview/MonthEndReopeningsController'
import _frontOverviewYears from './Front/Overview/YearsController'
import _frontPasskeys from './Front/PasskeysController'
import _frontPasskeysAuthenticationChallenges from './Front/Passkeys/AuthenticationChallengesController'
import _frontPasskeysReauthentications from './Front/Passkeys/ReauthenticationsController'
import _frontPasskeysRegistrationChallenges from './Front/Passkeys/RegistrationChallengesController'
import _frontPasskeysSessions from './Front/Passkeys/SessionsController'
import _frontPaymentsCashTransfers from './Front/Payments/CashTransfersController'
import _frontPaymentsCategoryRuleDrafts from './Front/Payments/CategoryRuleDraftsController'
import _frontPaymentsCategoryTakeovers from './Front/Payments/CategoryTakeoversController'
import _frontPaymentsCounterparties from './Front/Payments/CounterpartiesController'
import _frontPaymentsCounterpartyRuleDrafts from './Front/Payments/CounterpartyRuleDraftsController'
import _frontPaymentsCreditNotes from './Front/Payments/CreditNotesController'
import _frontPaymentsDocuments from './Front/Payments/DocumentsController'
import _frontPaymentsInvoices from './Front/Payments/InvoicesController'
import _frontPaymentsPayments from './Front/Payments/PaymentsController'
import _frontPaymentsReferenceDocuments from './Front/Payments/ReferenceDocumentsController'
import _frontPaymentsReplacementDocuments from './Front/Payments/ReplacementDocumentsController'
import _frontPaymentsSyncAccounts from './Front/Payments/SyncAccountsController'
import _pages from './PagesController'
import _frontProducts from './Front/ProductsController'
import _frontProductsPrices from './Front/Products/PricesController'
import _frontProfiles from './Front/ProfilesController'
import _frontPurchaseOrdersApprovals from './Front/PurchaseOrders/ApprovalsController'
import _frontPurchaseOrdersDeliveries from './Front/PurchaseOrders/DeliveriesController'
import _frontPurchaseOrdersDuplicates from './Front/PurchaseOrders/DuplicatesController'
import _frontPurchaseOrdersFinalizations from './Front/PurchaseOrders/FinalizationsController'
import _frontPurchaseOrdersPdfs from './Front/PurchaseOrders/PdfsController'
import _frontPurchaseOrdersPreviews from './Front/PurchaseOrders/PreviewsController'
import _frontPurchaseOrdersStatuses from './Front/PurchaseOrders/StatusesController'
import _frontQuestions from './Front/QuestionsController'
import _frontQuestionsMessages from './Front/Questions/MessagesController'
import _frontRecurringInvoicesPauses from './Front/RecurringInvoices/PausesController'
import _frontRecurringInvoicesRuns from './Front/RecurringInvoices/RunsController'
import _frontReminderSettings from './Front/ReminderSettingsController'
import _frontDevActions from './Front/DevActionsController'
import _frontSalesDocumentsAcceptances from './Front/SalesDocuments/AcceptancesController'
import _frontSalesDocumentsAdvanceInvoices from './Front/SalesDocuments/AdvanceInvoicesController'
import _frontSalesDocumentsConversions from './Front/SalesDocuments/ConversionsController'
import _frontSalesDocumentsDeclines from './Front/SalesDocuments/DeclinesController'
import _frontSalesDocumentsDeliveries from './Front/SalesDocuments/DeliveriesController'
import _frontSalesDocumentsDuplicates from './Front/SalesDocuments/DuplicatesController'
import _frontSalesDocumentsFinalizations from './Front/SalesDocuments/FinalizationsController'
import _frontSalesDocumentsPdfs from './Front/SalesDocuments/PdfsController'
import _frontSalesDocumentsPreviews from './Front/SalesDocuments/PreviewsController'
import _frontShowcaseSessions from './Front/ShowcaseSessionsController'
import _frontUsers from './Front/UsersController'
import _frontStores from './Front/StoresController'
import _frontTeamFirmsEngagements from './Front/Team/Firms/EngagementsController'
import _frontTeamInvitations from './Front/Team/InvitationsController'
import _frontTeamInvitationsDeliveries from './Front/Team/Invitations/DeliveriesController'
import _frontTeamMembers from './Front/Team/MembersController'
import _frontTeamMembersCompanies from './Front/Team/Members/CompaniesController'
import _frontTeamMembersReactivations from './Front/Team/Members/ReactivationsController'
import _turboNativeNavigation from './Turbo/Native/NavigationController'

export const acceptPaymentMatchingRule = _frontPaymentMatchingRules.accept
export const account = _frontAccounts.show
export const accountName = _frontAccountNames.update
export const accountSelection = _frontAccountSelections.create
export const accountSetting = _frontSettings.show
export const accountantClient = _frontAccountantClients.show
export const accountantClientChartApproval = _frontAccountantClientsChartApprovals.create
export const accountantClientLedgerAccount = _frontAccountantClientsLedgerAccounts.update
export const accountantClientLedgerAccounts = _frontAccountantClientsLedgerAccounts.create
export const accountantClientPeriodStart = _frontAccountantClientsPeriodStarts.update
export const accountantClientSetup = _frontAccountantClientsSetups.show
export const accountantClientStart = _frontAccountantClientsStarts.update
export const accountantClients = _frontAccountantClients.index
export const accountantDeadlines = _frontAccountantDeadlines.index
export const accountantFirm = _frontAccountantFirms.show
export const accountantFirmAssignment = _frontAccountantFirmAssignments.destroy
export const accountantFirmAssignments = _frontAccountantFirmAssignments.create
export const accountantFirmEngagement = _frontAccountantFirmEngagements.destroy
export const accountantFirmStaff = _frontAccountantFirmStaff.destroy
export const accountantFirmStaffIndex = _frontAccountantFirmStaff.create
export const accountantOnboarding = _frontAccountantOnboardings.index
export const accountantOnboardingStep = _frontAccountantOnboardings.show
export const accountantProfile = _frontAccountantProfiles.show
export const accountantRoot = _Routes.accountantRoot
export const activities = _frontActivities.index
export const activityDismissal = _frontActivitiesDismissals.create
export const appleAppSiteAssociation = _appleAppSiteAssociations.show
export const archiveDuplicatesDocuments = _frontDocuments.archiveDuplicates
export const authGoogleOauth2Callback = _frontUsersOauthCallbacks.google
export const bankAccount = _frontBankAccounts.show
export const bankAccountRawBankTransactions = _frontBankAccountsRawBankTransactions.index
export const bankAccountStatement = _frontBankAccountsStatements.show
export const bankAccounts = _frontBankAccounts.index
export const bankConnection = _frontBankConnections.destroy
export const bankConnectionAuthorization = _frontBankConnectionsAuthorizations.create
export const bankConnectionCallback = _frontBankConnectionsCallbacks.show
export const bankConnectionInstitutionSelection = _frontBankConnectionsInstitutionSelections.update
export const bankConnectionInstitutions = _frontBankConnectionsInstitutions.index
export const bankConnections = _frontBankConnections.index
export const bankStatementFile = _frontBankStatementFiles.show
export const bankStatementFileAssignment = _frontBankStatementFilesAssignments.update
export const bankStatementFilePdf = _frontBankStatementFilesPdfs.show
export const bankStatementFiles = _frontBankStatementFiles.index
export const bankStatementUpload = _frontBankStatementUploads.show
export const bankStatementUploadBankAccount = _frontBankStatementUploadsBankAccounts.update
export const bankStatementUploadRow = _frontBankStatementUploadsRows.update
export const bankStatementUploadRows = _frontBankStatementUploadsRows.create
export const bankStatementUploads = _Routes.bankStatementUploads
export const bankSync = _frontBankSyncs.show
export const bankSyncAcknowledgement = _frontBankSyncsAcknowledgements.create
export const bankSyncRetry = _frontBankSyncsRetries.create
export const bulkCounterparties = _frontBulkCounterparties.create
export const bulkDestroyDocuments = _frontDocuments.bulkDestroy
export const bulkDetachDocuments = _frontDocuments.bulkDetach
export const bulkDetachPayments = _frontPayments.bulkDetach
export const bulkExtracts = _frontBulkExtracts.create
export const bulkUpdateCashFlowDirectionDocuments = _frontDocuments.bulkUpdateCashFlowDirection
export const bulkUpdateCategoryPayments = _frontPayments.bulkUpdateCategory
export const bulkUpdateCounterpartyDocuments = _frontDocuments.bulkUpdateCounterparty
export const bulkUpdateDirectionPayments = _frontPayments.bulkUpdateDirection
export const cashAccount = _frontCashAccounts.update
export const cashAccountCashCounts = _frontCashAccountsCashCounts.create
export const cashAccounts = _frontCashAccounts.create
export const companies = _frontCompanies.index
export const companyArchive = _frontCompaniesArchives.create
export const companyIdentity = _frontCompanyIdentities.destroy
export const companyIdentityConfirmation = _frontCompanyIdentityConfirmations.show
export const confirmBankStatementUpload = _frontBankStatementUploads.confirm
export const confirmLogin = _frontUsersSessions.confirm
export const counterparties = _frontCounterparties.index
export const counterpartiesBulkDeletion = _frontCounterpartiesBulkDeletions.create
export const counterparty = _frontCounterparties.show
export const counterpartyContact = _frontCounterpartiesContacts.update
export const counterpartyContacts = _frontCounterpartiesContacts.create
export const counterpartyMerge = _frontCounterpartiesMerges.create
export const counterpartyRole = _frontCounterpartiesRoles.update
export const counterpartySettlementSales = _frontCounterpartiesSettlementSales.update
export const counterpartyStatement = _frontCounterpartiesStatements.show
export const disablePaymentMatchingRule = _frontPaymentMatchingRules.disable
export const document = _frontDocuments.show
export const documentCashDiscount = _frontDocumentsCashDiscounts.destroy
export const documentCashDiscounts = _frontDocumentsCashDiscounts.create
export const documentCashPayment = _frontDocumentsCashPayments.create
export const documentCompany = _frontDocumentsCompanies.update
export const documentCounterparties = _frontDocumentsCounterparties.create
export const documentCounterparty = _frontDocumentsCounterparties.update
export const documentDetailedExtractions = _frontDocumentsDetailedExtractions.create
export const documentDocument = _frontDocumentsDocuments.destroy
export const documentDocuments = _frontDocumentsDocuments.create
export const documentExtractions = _frontDocumentsExtractions.create
export const documentImages = _frontDocumentsImages.create
export const documentInvoicePdf = _frontDocumentsInvoicePdfs.create
export const documentPayment = _frontDocumentsPayments.destroy
export const documentPayments = _frontDocumentsPayments.create
export const documentPurchaseOrder = _frontDocumentsPurchaseOrders.destroy
export const documentRebill = _frontDocumentsRebills.update
export const documentReview = _frontDocumentsReviews.show
export const documentReviewCompletion = _frontDocumentsReviewCompletions.create
export const documentReviewDecisions = _frontDocumentsReviewDecisions.create
export const documents = _frontDocuments.index
export const documentsDeliveryDate = _frontDocumentsDeliveryDates.show
export const documentsDeliveryDates = _frontDocumentsDeliveryDates.index
export const documentsReviewQueue = _frontDocumentsReviewQueues.show
export const editAccount = _frontAccounts.edit
export const editAccountSetting = _frontSettings.edit
export const editDocument = _frontDocuments.edit
export const editInvoice = _frontInvoices.edit
export const editLedgerManualJournal = _frontLedgerManualJournals.edit
export const editPurchaseOrder = _frontPurchaseOrders.edit
export const editRecurringInvoice = _frontRecurringInvoices.edit
export const editSalesDocument = _frontSalesDocuments.edit
export const extractTextIncomingEmail = _frontIncomingEmails.extractText
export const feedbacks = _frontFeedbacks.create
export const googleOauthStart = _frontUsersOauthStarts.google
export const ideaBoard = _ideaBoardIdeas.index
export const ideaBoardIdeaComments = _ideaBoardComments.create
export const ideaBoardIdeaVote = _ideaBoardVotes.destroy
export const incomingEmail = _frontIncomingEmails.show
export const incomingEmailAllowedSender = _frontIncomingEmailAllowedSenders.destroy
export const incomingEmailAllowedSenders = _frontIncomingEmailAllowedSenders.index
export const incomingEmailItemAssignment = _frontIncomingEmailItemsAssignments.create
export const incomingEmailItemSkip = _frontIncomingEmailItemsSkips.create
export const incomingEmails = _frontIncomingEmails.index
export const invitation = _frontUsersInvitations.show
export const invoice = _frontInvoices.show
export const invoiceAttachment = _frontInvoicesAttachments.destroy
export const invoiceAttachments = _frontInvoicesAttachments.create
export const invoiceCancellation = _frontInvoicesCancellations.create
export const invoiceCreditNotes = _frontInvoicesCreditNotes.create
export const invoiceDeliveries = _frontInvoicesDeliveries.create
export const invoiceDuplicate = _frontInvoicesDuplicates.create
export const invoiceImport = _frontInvoiceImports.show
export const invoiceIssue = _frontInvoicesIssues.create
export const invoicePreview = _frontInvoicesPreviews.show
export const invoiceRebilledExpenses = _frontInvoicesRebilledExpenses.create
export const invoiceReminders = _frontInvoicesReminders.create
export const invoiceSettings = _frontInvoiceSettings.update
export const invoiceSettlement = _frontInvoicesSettlements.destroy
export const invoiceSettlements = _frontInvoicesSettlements.create
export const invoiceTemplate = _frontInvoiceTemplates.destroy
export const invoiceTemplateDrafts = _frontInvoiceTemplatesDrafts.create
export const invoiceTemplates = _frontInvoiceTemplates.create
export const invoices = _frontInvoices.index
export const ledgerAccount = _frontLedgerAccounts.show
export const ledgerAccounts = _frontLedgerAccounts.index
export const ledgerBalanceSheet = _frontLedgerBalanceSheets.show
export const ledgerBatchVerification = _frontLedgerBatchVerifications.create
export const ledgerCounterparties = _frontLedgerCounterparties.index
export const ledgerCounterparty = _frontLedgerCounterparties.show
export const ledgerCounterpartyConfirmation = _frontLedgerCounterpartiesConfirmations.create
export const ledgerCounterpartyCorrection = _frontLedgerCounterpartiesCorrections.update
export const ledgerDocument = _frontLedgerDocuments.show
export const ledgerDocumentBreakdown = _frontLedgerDocumentsBreakdowns.update
export const ledgerDocumentCorrection = _frontLedgerDocumentsCorrections.update
export const ledgerDocumentExpenseAccount = _frontLedgerDocumentsExpenseAccounts.update
export const ledgerDocumentPostingRule = _frontLedgerDocumentsPostingRules.update
export const ledgerDocumentQuestions = _frontLedgerDocumentsQuestions.create
export const ledgerDocumentVerification = _frontLedgerDocumentsVerifications.destroy
export const ledgerDocuments = _frontLedgerDocuments.index
export const ledgerExport = _frontLedgerJournalEntriesExports.show
export const ledgerIssueResolution = _frontLedgerIssuesResolutions.create
export const ledgerJournalEntries = _frontLedgerJournalEntries.index
export const ledgerManualJournal = _frontLedgerManualJournals.update
export const ledgerManualJournalPosting = _frontLedgerManualJournalsPostings.create
export const ledgerManualJournals = _frontLedgerManualJournals.index
export const ledgerPayment = _frontLedgerPayments.show
export const ledgerPaymentCategory = _frontLedgerPaymentsCategories.update
export const ledgerPaymentDocument = _frontLedgerPaymentsDocuments.destroy
export const ledgerPaymentDocuments = _frontLedgerPaymentsDocuments.create
export const ledgerPaymentQuestions = _frontLedgerPaymentsQuestions.create
export const ledgerPaymentVerification = _frontLedgerPaymentsVerifications.destroy
export const ledgerPayments = _frontLedgerPayments.index
export const ledgerPeriod = _frontLedgerPeriods.show
export const ledgerPeriodApproval = _frontLedgerPeriodsApprovals.destroy
export const ledgerPeriodFiling = _frontLedgerPeriodsFilings.update
export const ledgerPeriodPreparation = _frontLedgerPeriodsPreparations.destroy
export const ledgerPeriods = _frontLedgerPeriods.index
export const ledgerProfitAndLoss = _frontLedgerProfitAndLosses.show
export const ledgerQuestionMessages = _frontLedgerQuestionsMessages.create
export const ledgerQuestionReminder = _frontLedgerQuestionReminders.create
export const ledgerQuestionResolution = _frontLedgerQuestionsResolutions.create
export const ledgerReview = _frontLedgerReviews.show
export const ledgerReviewQueue = _frontLedgerReviewQueues.show
export const ledgerReviewQueueCounterparty = _frontLedgerReviewQueuesCounterparties.show
export const ledgerReviewQueuePayment = _frontLedgerReviewQueuesPayments.show
export const ledgerReviewQueuePaymentGroups = _frontLedgerReviewQueuesPaymentGroups.show
export const ledgerReviewQueuePaymentVerification = _frontLedgerReviewQueuesPaymentsVerifications.create
export const ledgerReviewQueueVerification = _frontLedgerReviewQueuesVerifications.create
export const ledgerTrialBalance = _frontLedgerTrialBalances.show
export const ledgerTrustRule = _frontLedgerTrustRules.destroy
export const ledgerTrustRules = _frontLedgerTrustRules.create
export const ledgerVatReturn = _frontLedgerVatReturns.show
export const ledgerVatReturnDeclaration = _frontLedgerVatReturnsDeclarations.show
export const ledgerVatReturnExport = _frontLedgerVatReturnsExports.show
export const ledgerVatReturnSummary = _frontLedgerVatReturnsSummaries.show
export const ledgerVatSettings = _frontLedgerVatSettings.update
export const ledgerViesReturn = _frontLedgerViesReturns.show
export const ledgerViesReturnDeclaration = _frontLedgerViesReturnsDeclarations.show
export const ledgerViesReturnExport = _frontLedgerViesReturnsExports.show
export const ledgerViesReturnFiling = _frontLedgerViesReturnsFilings.create
export const login = _frontUsersSessions.create
export const loginCode = _frontUsersLoginCodes.create
export const logout = _frontUsersSessions.destroy
export const magicLogin = _frontUsersSessions.magicLink
export const markProcessedBankStatementUploadRow = _frontBankStatementUploadsRows.markProcessed
export const mobileDevice = _frontMobileDevices.destroy
export const mobilePairing = _frontMobilePairings.create
export const mobilePairingLink = _mobilePairingLinks.show
export const newLedgerManualJournal = _frontLedgerManualJournals.new
export const newLogin = _frontUsersSessions.new
export const newRecurringInvoice = _frontRecurringInvoices.new
export const onboarding = _frontOnboarding.index
export const onboardingStep = _frontOnboarding.show
export const overviewDashboard = _frontOverviewDashboards.show
export const overviewMatchSuggestionAcceptance = _frontOverviewMatchSuggestionsAcceptances.create
export const overviewMatchSuggestionRejection = _frontOverviewMatchSuggestionsRejections.create
export const overviewMonthEnd = _frontOverviewMonthEnds.show
export const overviewMonthEndAutoMatch = _frontOverviewMonthEndAutoMatches.create
export const overviewMonthEndConnection = _frontOverviewMonthEndConnections.destroy
export const overviewMonthEndExport = _frontOverviewMonthEndExports.create
export const overviewMonthEndHandOver = _frontOverviewMonthEndHandOvers.create
export const overviewMonthEndReopening = _frontOverviewMonthEndReopenings.create
export const overviewYear = _frontOverviewYears.show
export const passkey = _frontPasskeys.destroy
export const passkeys = _frontPasskeys.create
export const passkeysAuthenticationChallenge = _frontPasskeysAuthenticationChallenges.create
export const passkeysReauthentication = _frontPasskeysReauthentications.update
export const passkeysRegistrationChallenge = _frontPasskeysRegistrationChallenges.create
export const passkeysSession = _frontPasskeysSessions.create
export const payment = _frontPayments.show
export const paymentCashTransfer = _frontPaymentsCashTransfers.destroy
export const paymentCategoryRuleDraft = _frontPaymentsCategoryRuleDrafts.show
export const paymentCategoryTakeover = _frontPaymentsCategoryTakeovers.create
export const paymentCounterparty = _frontPaymentsCounterparties.update
export const paymentCounterpartyRuleDraft = _frontPaymentsCounterpartyRuleDrafts.show
export const paymentCreditNotes = _frontPaymentsCreditNotes.create
export const paymentDocument = _frontPaymentsDocuments.destroy
export const paymentDocuments = _frontPaymentsDocuments.create
export const paymentInvoices = _frontPaymentsInvoices.create
export const paymentMatchingRule = _frontPaymentMatchingRules.show
export const paymentMatchingRules = _frontPaymentMatchingRules.index
export const paymentPayment = _frontPaymentsPayments.destroy
export const paymentPayments = _frontPaymentsPayments.create
export const paymentReferenceDocument = _frontPaymentsReferenceDocuments.update
export const paymentReplacementDocuments = _frontPaymentsReplacementDocuments.create
export const payments = _frontPayments.index
export const paymentsSyncAccounts = _frontPaymentsSyncAccounts.create
export const privacy = _pages.privacy
export const processAttachmentsIncomingEmail = _frontIncomingEmails.processAttachments
export const product = _frontProducts.update
export const productPrice = _frontProductsPrices.destroy
export const productPrices = _frontProductsPrices.create
export const products = _frontProducts.index
export const profile = _frontProfiles.update
export const purchaseOrder = _frontPurchaseOrders.show
export const purchaseOrderApproval = _frontPurchaseOrdersApprovals.create
export const purchaseOrderDeliveries = _frontPurchaseOrdersDeliveries.create
export const purchaseOrderDuplicate = _frontPurchaseOrdersDuplicates.create
export const purchaseOrderFinalization = _frontPurchaseOrdersFinalizations.create
export const purchaseOrderPdf = _frontPurchaseOrdersPdfs.show
export const purchaseOrderPreview = _frontPurchaseOrdersPreviews.show
export const purchaseOrderStatus = _frontPurchaseOrdersStatuses.update
export const purchaseOrders = _frontPurchaseOrders.index
export const question = _frontQuestions.show
export const questionMessages = _frontQuestionsMessages.create
export const recurringInvoice = _frontRecurringInvoices.update
export const recurringInvoicePause = _frontRecurringInvoicesPauses.destroy
export const recurringInvoiceRuns = _frontRecurringInvoicesRuns.create
export const recurringInvoices = _frontRecurringInvoices.index
export const reenablePaymentMatchingRule = _frontPaymentMatchingRules.reenable
export const rejectAllPaymentMatchingRules = _frontPaymentMatchingRules.rejectAll
export const rejectPaymentMatchingRule = _frontPaymentMatchingRules.reject
export const reminderSettings = _frontReminderSettings.update
export const reset = _frontDevActions.reset
export const root = _pages.main
export const salesDocument = _frontSalesDocuments.show
export const salesDocumentAcceptance = _frontSalesDocumentsAcceptances.create
export const salesDocumentAdvanceInvoices = _frontSalesDocumentsAdvanceInvoices.create
export const salesDocumentConversions = _frontSalesDocumentsConversions.create
export const salesDocumentDecline = _frontSalesDocumentsDeclines.create
export const salesDocumentDeliveries = _frontSalesDocumentsDeliveries.create
export const salesDocumentDuplicate = _frontSalesDocumentsDuplicates.create
export const salesDocumentFinalization = _frontSalesDocumentsFinalizations.create
export const salesDocumentPdf = _frontSalesDocumentsPdfs.show
export const salesDocumentPreview = _frontSalesDocumentsPreviews.show
export const salesDocuments = _frontSalesDocuments.index
export const showcase = _frontShowcaseSessions.new
export const signup = _frontUsers.new
export const store = _frontStores.update
export const stores = _frontStores.create
export const teamFirmEngagement = _frontTeamFirmsEngagements.destroy
export const teamInvitation = _frontTeamInvitations.destroy
export const teamInvitationDelivery = _frontTeamInvitationsDeliveries.create
export const teamInvitations = _frontTeamInvitations.create
export const teamMember = _frontTeamMembers.update
export const teamMemberCompanies = _frontTeamMembersCompanies.update
export const teamMemberReactivation = _frontTeamMembersReactivations.create
export const terms = _pages.terms
export const turboRecedeHistoricalLocation = _turboNativeNavigation.recede
export const turboRefreshHistoricalLocation = _turboNativeNavigation.refresh
export const turboResumeHistoricalLocation = _turboNativeNavigation.resume
export const users = _frontUsers.create
export const verifyLogin = _frontUsersSessions.verify
